export const Types = {
    SPARE_PARTS_EXCEL_GET_EXCEL_LIST: "SPARE_PARTS_EXCEL_GET_EXCEL_LIST",
    SPARE_PARTS_EXCEL_SET_EXCEL_LIST: "SPARE_PARTS_EXCEL_SET_EXCEL_LIST",
    SPARE_PARTS_EXCEL_UPLOAD_FILE: "SPARE_PARTS_EXCEL_UPLOAD_FILE",
    SPARE_PARTS_SET_EXCEL_UPLOAD_FILE: "SPARE_PARTS_SET_EXCEL_UPLOAD_FILE",
    SPARE_PARTS_EXCEL_EXCEL_FILE_OUTLINE: "SPARE_PARTS_EXCEL_EXCEL_FILE_OUTLINE",
    SPARE_PARTS_UNPLANNED_EXCEL_FILE_OUTLINE: "SPARE_PARTS_UNPLANNED_EXCEL_FILE_OUTLINE",
    SPARE_PARTS_PLANNED_EXCEL_FILE_OUTLINE: "SPARE_PARTS_PLANNED_EXCEL_FILE_OUTLINE",
};

export const getExcelList = (payload) => ({
    type: Types.SPARE_PARTS_EXCEL_GET_EXCEL_LIST,
    payload,
});

export const setExcelList = (payload) => ({
    type: Types.SPARE_PARTS_EXCEL_SET_EXCEL_LIST,
    payload,
});

export const getPostExcelUpload = (payload) => ({
    type: Types.SPARE_PARTS_EXCEL_UPLOAD_FILE,
    payload,
});

export const setPostExcelUpload = (payload) => ({
    type: Types.SPARE_PARTS_SET_EXCEL_UPLOAD_FILE,
    payload,
});

export const downloadExcelFile = (payload) => ({
    type: Types.SPARE_PARTS_EXCEL_EXCEL_FILE_OUTLINE,
    payload,
});

export const downloadUnplannedExcelFile =(payload) => ({
    type: Types.SPARE_PARTS_UNPLANNED_EXCEL_FILE_OUTLINE,
    payload,
});

export const downloadPlannedExcelFile =(payload) => ({
    type: Types.SPARE_PARTS_PLANNED_EXCEL_FILE_OUTLINE,
    payload,
});